import axios from "axios";
import * as SecurityService from "../../application/services/SecurityService";

import { urlInscriptionsByDni, urlRejectedRequirements, urlSendToPending, urlInscriptionDniAndId, urlProcessInscriptionsData, urlEditInscriptionAddress, urlEditInscriptionNotification, orderedBy, urlIncidentsMeritsInfo, urlEditInscriptionRepresentativeAddress, urlEditInscriptionRepresentativeNotification } from "./services.config";
import { Address } from "../../domain/entities/inscriptionStructure/Address";
import { ContactData } from "../../domain/entities/inscriptionStructure/ContactData";

var mgr = new SecurityService.default();

async function setToken() {
    await mgr.getAcessToken().then(
        acessToken => {
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + acessToken
        }, err => {
            console.log(err)
        })
}

export let getInscriptionsDni = async function (dni: string) {
    await setToken();
    return new Promise((resolve, reject) => {
        resolve(axios.get(urlInscriptionsByDni(dni) + orderedBy('inscriptionDate', true)));
    })
}

export let getProcessInscriptionsData = async function (dni: string, id: string) {
    await setToken();
    return new Promise((resolve, reject) => {
        resolve(axios.get(urlProcessInscriptionsData(dni, id)));
    })
}

export let getRejectedRequirements = async function (nif: string, inscriptionId: string) {
    await setToken();
    return new Promise((resolve, reject) => {
        resolve(axios.get(urlRejectedRequirements(nif, inscriptionId)));
    })
}

export let sendRejectedRequirementToPending = async function (nif: string, inscriptionId: string, cryptoSignatureToServer: any) {
    await setToken();
    return new Promise((resolve, reject) => {
        resolve(axios.put(urlSendToPending(nif, inscriptionId), cryptoSignatureToServer));
    })
}

export let getInscriptionDniAndId = async function (nif: string, inscriptionId: string) {
    await setToken();
    return new Promise((resolve, reject) => {
        resolve(axios.get(urlInscriptionDniAndId(nif, inscriptionId)));
    })
}

export let sendEditInscriptionAddress = async function (nif: string, address: Address) {
    await setToken();
    return new Promise((resolve, reject) => {
        resolve(axios.put(urlEditInscriptionAddress(nif, address), address.toServer()));
    })
}

export let sendEditInscriptionNotification = async function (nif: string, contactData: ContactData) {
    await setToken();
    return new Promise((resolve, reject) => {
        resolve(axios.put(urlEditInscriptionNotification(nif, contactData), contactData.toServer()));
    })
}

export let sendEditInscriptionRepresentativeAddress = async function (nif: string, address: Address) {
    await setToken();
    return new Promise((resolve, reject) => {
        resolve(axios.put(urlEditInscriptionRepresentativeAddress(nif, address), address.toServer()));
    })
}

export let sendEditInscriptionRepresentativeNotification = async function (nif: string, contactData: { email: string, inscriptionId: string}) {
    await setToken();
    return new Promise((resolve, reject) => {
        resolve(axios.put(urlEditInscriptionRepresentativeNotification(nif, contactData.inscriptionId), contactData));
    })
}

export let getMeritsWithIncidents = async function (nif: string, inscriptionId: string) {
    await setToken();
    return new Promise((resolve, reject) => {
        resolve(axios.get(urlIncidentsMeritsInfo(nif, inscriptionId)));
    })
}
